import React, {useEffect, useState} from 'react'
import {ChevronLeftIcon, XMarkIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";
import _ from "lodash";
import {COLOR_LIST} from "../constants/color.constant";
import {COLOR_STOP_LIST} from "../../design/constants/design.constant";

const RenderFields = ({
                          fieldList,
                          parentForm,
                          handleDetailChanges,
                          enableEdit,
                          enableEditOnHover = false,
                          fieldClassName = 'w-full',
                          noFieldLabel = false
                      }) => {

    return (
        <>
            {fieldList?.map((field, index) => (

                <React.Fragment key={index}>
                    {field?.type === 'text' &&
                        <div
                            className={`field-container ${field?.cssClass ? field?.cssClass : fieldClassName}`}>
                            {!noFieldLabel &&
                                <div className="field-label w-full">
                                    {field?.label}
                                </div>
                            }
                            <input
                                type="text"
                                className="input-field-max w-full"
                                disabled={field?.readOnly || !enableEdit}
                                id={field?.attribute}
                                name={field?.attribute}
                                placeholder={field?.label}
                                value={parentForm[field?.attribute] || ''}
                                onChange={handleDetailChanges}>
                            </input>
                        </div>
                    }

                    {field?.type === 'date' &&
                        <div className={`field-container ${fieldClassName}`}>
                            {!noFieldLabel &&
                                <div className="field-label w-full">
                                    {field?.label}
                                </div>
                            }
                            <input
                                type="date"
                                className="input-field-max w-full"
                                disabled={field?.readOnly || !enableEdit}
                                id={field?.attribute}
                                name={field?.attribute}
                                placeholder={field?.label}
                                value={parentForm[field?.attribute] || ''}
                                onChange={handleDetailChanges}>
                            </input>
                        </div>
                    }

                    {field?.type === 'number' &&
                        <div
                            className={`field-container ${field?.cssClass ? field?.cssClass : fieldClassName}`}>
                            {!noFieldLabel &&
                                <div className="field-label w-full">
                                    {field?.label}
                                </div>
                            }
                            <input
                                type="number"
                                className="input-field-max w-full"
                                disabled={field?.readOnly || !enableEdit}
                                id={field?.attribute}
                                name={field?.attribute}
                                placeholder={field?.label}
                                value={parentForm[field?.attribute]}
                                onChange={handleDetailChanges}>
                            </input>
                        </div>
                    }

                    {field?.type === 'checkbox' &&
                        <div
                            className={`items-center mt-4 justify-start flex field-container ${field?.cssClass ? field?.cssClass : fieldClassName}`}>
                            <input
                                type="checkbox"
                                className="h-6 w-6 mr-1 cursor-pointer"
                                disabled={field?.readOnly || !enableEdit}
                                id={field?.attribute}
                                name={field?.attribute}
                                checked={parentForm[field?.attribute]}
                                onChange={handleDetailChanges}>
                            </input>
                            <div className=''>
                                <label className='field-label cursor-pointer self-center ml-1 mt-1'
                                       htmlFor={field?.attribute}>{field?.label}</label>
                            </div>
                        </div>
                    }

                    {field?.type === 'text-area' &&
                        <div className={`field-container ${fieldClassName}`}>
                            {!noFieldLabel &&
                                <div className="field-label w-full">
                                    {field?.label}
                                </div>
                            }
                            <textarea
                                rows={field?.rows || 10}
                                disabled={field?.readOnly || !enableEdit}
                                id={field?.attribute}
                                name={field?.attribute}
                                placeholder={field?.label}
                                value={parentForm[field?.attribute] || ''}
                                onChange={handleDetailChanges}
                                className={`input-field-max w-full ${field?.class}`}/>
                        </div>
                    }

                    {field?.type === 'select' &&
                        <div className={`field-container ${field?.cssClass} ${fieldClassName}`}>
                            {!noFieldLabel &&
                                <div className="field-label w-full">
                                    {field?.label}
                                </div>
                            }
                            <select
                                disabled={field?.readOnly || !enableEdit}
                                className="select-input-field w-full"
                                id={field?.attribute}
                                name={field?.attribute}
                                value={parentForm[field?.attribute] || field?.default || ''}
                                onChange={handleDetailChanges}>
                                <option value="">Choose</option>
                                {field?.options?.map((option, index) => (
                                    <option key={index}
                                            value={option.key}>{option.label}</option>
                                ))}

                            </select>
                        </div>
                    }
                </React.Fragment>

            ))}
        </>
    )
}

export default RenderFields
